export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
export const RETRIEVE_USER_DETAILS_SUCCESS =
	'auth/RETRIEVE_USER_DETAILS_SUCCESS';
export const RETRIEVE_USER_PERMISSIONS_SUCCESS =
	'auth/RETRIEVE_USER_PERMISSIONS_SUCCESS';
